export default {
  step: null,
  questions: [
    {
      section: 'Dados da agência',
      title: 'Endereço de e-mail:',
      label: 'Email',
      field: 'email',
      type: 'text',
      value: ''
    },
    {
      section: 'Dados da agência',
      title: 'Estado da agência:',
      label: 'Selecione',
      field: 'estadoAgencia',
      type: 'select',
      items: [
        'Acre',
        'Alagoas',
        'Amapá',
        'Amazonas',
        'Bahia',
        'Ceará',
        'Distrito Federal',
        'Espírito Santo',
        'Goías',
        'Maranhão',
        'Mato Grosso',
        'Mato Grosso do Sul',
        'Minas Gerais',
        'Pará',
        'Paraíba',
        'Paraná',
        'Pernambuco',
        'Piauí',
        'Rio de Janeiro',
        'Rio Grande do Norte',
        'Rio Grande do Sul',
        'Rondônia',
        'Roraíma',
        'Santa Catarina',
        'São Paulo',
        'Sergipe',
        'Tocantins'
      ],
      value: ''
    },
    {
      section: 'Dados da agência',
      title: 'Município da agência:',
      label: 'Município',
      field: 'municipioAgencia',
      type: 'text',
      value: ''
    },
    {
      section: 'Dados da agência',
      title: 'Cliente:',
      required: false,
      label: 'Nome do cliente',
      field: 'nomeCliente',
      type: 'text',
      value: ''
    },
    {
      section: 'Sobre a concorrência',
      title: 'Início da concorrência:',
      label: 'Data',
      field: 'inicioConcorrencia',
      type: 'date',
      moment: 'MM-yyyy',
      value: ''
    },
    {
      section: 'Sobre a concorrência',
      title: 'Esta concorrência é para renovação de contrato de cliente já atendido por sua agência ou é um novo contrato, com novo cliente?',
      field: 'renovacaoNovoNegocio',
      type: 'options',
      options: ['Renovação de contrato com cliente já atendido', 'Não, é um novo negócio'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Foi concluída?',
      field: 'renovacaoConcluido',
      type: 'options',
      options: ['Sim', 'Não'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Se finalizada o tempo de duração da concorrência foi de:',
      field: 'duracaoConcorrencia',
      type: 'options',
      options: ['Até 5 dias', 'De 6 a 10 dias', 'De 11 a 20 dias', 'De 21 a 30 dias', 'De 31 a 60 dias', 'Mais de 60 dias'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Sobre o resultado, sua agência:',
      field: 'resultadoAgencia',
      type: 'options',
      options: ['Ganhou', 'Ganhou em parte', 'Perdeu a concorrência', 'Não teve resposta'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Tipo de contratação:',
      field: 'tipoContratacao',
      type: 'options',
      options: ['Fee mensal', 'Job por tempo determinado', 'Contrato fixo, mas execução mediante demanda'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Qual foi o objeto da contratação?',
      field: 'objetoContratacao',
      type: 'checkbox',
      options: ['Hora homem', 'Serviços e produtos', 'Estrutura de equipe dedicada'],
      value: []
    },
    {
      section: 'Sobre a concorrência',
      title: 'Qual foi a forma de prestação de serviço solicitada?',
      field: 'prestacaoServicoSolicitada',
      type: 'options',
      options: ['Equipe na agência', 'Equipe in company', 'Estrutura mista'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Em caso de contratação, qual o período previsto no contrato?',
      field: 'periodoPrevistoContrato',
      type: 'options',
      options: ['Até 1 mês', 'De 2 a 3 meses', 'De 4 a 6 meses', 'De 7 a 12 meses', 'De 13 a 24 meses', 'De 25 a 36 meses', 'Acima de 36 meses', 'Não ganhei a concorrência'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'No briefing, já havia indicação de verba mensal ou anual por parte do cliente?',
      field: 'verbaMensalAnual',
      type: 'options',
      options: ['Sim', 'Não'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Se ganhou a concorrência, houve negociação sobre o preço apresentado?',
      field: 'negociacaoPreco',
      type: 'options',
      options: ['Sim', 'Não', 'Não ganhei a concorrência'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Se houve negociação, qual o percentual de redução sobre o fee proposto pela agência?',
      field: 'percentualReducaoFEE',
      type: 'options',
      options: ['Até 5%', 'De 6% a 10%', 'De 11% a 15%', 'De 16% a 20%', 'De 21% a 25%', 'De 26% a 30%', 'Mais de 30%', 'Não ganhei a concorrência', 'Não houve negociação'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Indique nas faixas abaixo o valor final da concorrência no caso de contratação por job:',
      field: 'valorFinalContratacaoJob',
      type: 'options',
      options: ['Até R$50 mil', 'R$50 mil até R$100 mil', 'R$100 mil até R$200 mil', 'R$200 mil até R$500 mil', 'R$500 mil até R$1 milhão', 'Mais de R$1 milhão', 'Não ganhei a concorrência', 'Foi realizado outro modelo de contratação'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Indique nas faixas abaixo o valor final da concorrência no caso de contratação por fee:',
      field: 'valorFinalContratacaoFEE',
      type: 'options',
      options: ['Até R$50 mil', 'R$50 mil até R$100 mil', 'R$100 mil até R$200 mil', 'R$200 mil até R$500 mil', 'R$500 mil até R$1 milhão', 'Mais de R$1 milhão', 'Não ganhei a concorrência', 'Foi realizado outro modelo de contratação'],
      value: null
    },
    {
      section: 'Sobre a concorrência',
      title: 'Qual o segmento econômico do cliente?',
      field: 'segmentoEconomicoCliente',
      type: 'checkbox',
      options: ['B2B', 'B2C', 'Terceiro setor (ONGs, associações, sindicatos e afins)'],
      value: []
    },
    {
      section: 'Sobre a concorrência',
      title: 'Qual a área de atuação do cliente?',
      field: 'areaAtuacaoCliente',
      type: 'checkbox',
      options: ['ONG', 'Associação ou similar', 'Educação', 'Lazer, cultura, esporte', 'Moda e beleza', 'Tecnologia', 'Construção civil', 'Infraestrutura (energia, concessões rodoviárias etc)', 'Finanças', 'Varejo e Comércio em geral', 'Alimentação', 'Agronegócio', 'Turismo', 'Serviços (Escritórios de advocacia e/ou consultorias', 'Saúde (hospitais, clinicas)', 'Indústria Farmacêutica', 'Transporte e logística', 'Eletroeletrônicos', 'Setor automotivo (montadoras e autopeças)', 'Comunicação (editoras, emissoras de rádioe TV)', 'Nenhuma das Opções acima. Especifique na próxima questão.'],
      value: []

    },

    {
      section: 'Sobre a concorrência',
      title: 'Caso não tenha sido especificado a área de atuação do cliente na questão anterior, comente qual é área de atuação:',
      required: false,      
      field: 'areaAtuacaoClienteComent',
      label: 'Anote',
      type: 'text',
      value: ''

    },
    {
      section: 'Sobre a concorrência',
      title: 'Indique na lista a seguir os serviços previstos no briefing da concorrência:',
      field: 'servicosPrestadosConcorrencia',
      type: 'checkbox',
      options: ['Diagnóstico de comunicação', 'Plano estratégico de comunicação', 'Auditoria de imagem', 'Pesquisas aplicadas à comunicação', 'Elaboraçao de manual de prevenção de crises', 'Gerenciamento de crises', 'Atendimento à imprensa - nacional e regional', 'Atendimento à imprensa - internacional', 'Preparação de mailing de imprensa - nacional', 'Organização ou compra de mailing para ações de e-mail marketing, mala direta e afins', 'Análise continua de jornais, revistas e portais', 'Análise continua de TV e rádio', 'Mídia Traning e treinamentos em comunicação', 'Eventos para jornalistas (organização de entrevistas, workshops, encontros, viagens, visitas e afins)', 'Produçao de conteúdo impresso ou eletrônico em portugues (para portais, publicações e afins)', 'Produção de conteúdo em lingua estrangeira (não inclui tradução)', 'Produção de conteúdo para brandedcontent/infomerciais e afins', 'Produção de conteúdo para e-mail marketing, mala direta e afins', 'Fotografia', 'Produção de video', 'Produção de podcasts', 'Elaboração de projeto editorial para publicações impressas ou eletrônicas'],
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-1.html',
      title: 'Passo 1. Faça um briefing único e direto. defina o escopo da proposta deixando claras as necessidades de comunicações e objetivos.',
      subTitle: 'O briefing da empresa esclareceu as necessidades de comunicação e objetivos?',
      field: 'esclareceNecessidadeComunicacao',
      type: 'options',
      options: ['Não cumpriu a recomendação', 'Cumpriu parcialmente a recomendação', 'Cumpriu totalmente a recomendação'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'esclareceNecessidadeComunicacaoComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      title: 'Passo 2. dê tratamento igualitario e imparcial aos participantes.',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-2.html',
      subTitle: 'Você considera que todos os participantes foram tratados igualmente e de forma imparcial?',
      field: 'tratamentoIgualitarioParticipantes',
      type: 'options',
      options: ['Foi realizado briefing único com todos os participantes presencialmente', 'Foi realizado briefing online com todos os participantes', 'Foi realizado briefing online individualmente, sem conhecimento se foi igual para todos os participantes', 'Não cumpriu a recomendação'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'tratamentoIgualitarioParticipantesComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      title: 'Passo 3. Apresente cronograma com prazos exequíveis de acordo com a complexidade do projeto.',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-3.html',
      subTitle: 'Os prazos estabelecidos no briefing estavam de acordo com a complexidade?',
      field: 'prazoComplexidade',
      type: 'options',
      options: ['Sim', 'Não'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'A empresa contratante cumpriu o prazo de anúncio da agência vencedora previsto no edital/briefing?',
      field: 'prazoAnuncioEdital',
      type: 'options',
      options: ['Sim', 'Não'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Caso sua agência tenha vencido a concorrência e tenha ocorrido atraso no anúncio: isso prejudicou a montagem de equipe e estrutura para iniciar a prestação do serviço?',
      field: 'inicioServicoPrejudicado',
      type: 'options',
      options: ['Sim', 'Não', 'Não ganhei a concorrência'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'inicioServicoPrejudicadoComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-4.html',
      title: 'Passo 4. Estabeleça e divulgue os critérios de avaliação técnica e comercial.',
      subTitle: 'Os critérios de avaliação da proposta foram divulgados?',
      field: 'criteriosDivulgados',
      type: 'options',
      options: ['Sim', 'Não', 'Em parte'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'criteriosDivulgadosComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-5.html',
      title: 'Passo 5. Avalie as competências a partir do portifólio e do perfil das lideranças das empresas concorrentes. A equipe de atendimento será contratada após a definição da agência vencedora.',
      subTitle: 'Foram pedidos antecipadamente os currículos da equipe de atendimento?',
      field: 'curriculoEquipe',
      type: 'options',
      options: ['Sim', 'Não', 'Em parte'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'curriculoEquipeComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-6.html',
      title: 'Passo 6. Compartilhe as repostas aos questionamentos com todos os envolvidos.',
      subTitle: 'A empresa compartilhou com todos as respostas dadas aos questionamentos feitos pela agência?',
      field: 'compartilhamentoRespostas',
      type: 'options',
      options: ['Não cumpriu a recomendação', 'Cumpriu a recomendação parcialmente', 'Cumpriu totalmente a recomendação'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'compartilhamentoRespostasComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-7.html',
      title: 'Passo 7. Busque empresas que trabalham em conformidade com a legislação e verifique o regime de contratação da equipe.',
      subTitle: 'A empresa exigiu comprovaçao de contratação no regime CLT para a equipe de atendimento?',
      field: 'comprovacaoContratoCLT',
      type: 'options',
      options: ['Sim', 'Não'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Em caso de não ter sido feita exigência prévia, quais foram os modelos de contratação adotados pela sua agência para compor a equipe?',
      field: 'modeloContratacao',
      type: 'options',
      options: ['CLT', 'PJ', 'Ambos', 'Prefiro não responder'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'modeloContratacaoComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      title: 'Passo 8. Respeite os direitos autorais dos participantes.',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-8.html',
      subTitle: 'O cliente fez menção no briefing sobre direitos autorais das ideias criativas apresentadas nas propostas?',
      field: 'direitosAutoraisProposta',
      type: 'options',
      options: ['Mencionou no briefing respeito aos direitos autorais dos participantes', 'Não mencionou no briefing respeito aos direitos autorais dos participantes', 'A empresa exigiu a cessão das ideias apresentadas nas propostas'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Se sua agencia não ganhou, a empresa fez uso de propostas criativas apresentadas por sua agência?',
      type: 'options',
      field: 'propostaCriativa',
      options: ['Sim', 'Não', 'Não tive conhecimento', 'Minha agência ganhou a concorrência'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-9.html',
      title: 'Passo 9. Garanta a transparência ao processo e divulgue os resultados.',
      subTitle: 'Durante todas as etapas da concorrência foi percebida a transparência dos processos, com comunicados de todos os procedimentos, decisões e esclarecimentos de forma horizontal para o conjunto dos participantes? Responda, independentemente de sua agência ter ganho ou não a concorrência.',
      type: 'options',
      field: 'transparenciaProcesso',
      options: ['Cumpriu a recomendação', 'Cumpriu a recomendação parcialmente', 'Não cumpriu a recomendação'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'transparenciaProcessoComentario',
      type: 'textarea',
      value: ''
    },
    {
      section: 'Avaliando cada passo',
      url: 'https://www.abracom.org.br/concorrencialegal/passo-10.html',
      title: 'Passo 10. Dê um feedback detalhado.',
      subTitle: 'Houve um feedback sobre sua participação na concorrência, explicando agência ter ou não sido escolhida?',
      type: 'options',
      field: 'feedbackParticipacao',
      options: ['Sim', 'Deu feedback parcial', 'Não deu feedback'],
      value: null
    },
    {
      section: 'Avaliando cada passo',
      title: 'Comente:',
      required: false,
      label: 'Anote',
      field: 'feedbackParticipacaoComentario',
      type: 'textarea',
      value: ''
    }
  ]
}
